import React from 'react';

const DisplaySVG = ({ onClick }) => (
    <svg
        height="30"
        width="30"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 29.175 29.175"
        onClick={onClick} // Add onClick directly to the SVG
        xmlSpace="preserve"
    >
        <path
            style={{ fill: 'blue' }}
            d="m23.719 15.472-.706-.706-1.179 1.172v2.55l1.885 1.883zm0-7.038-1.885 1.86v2.565l1.179 1.2.706-.724zm-9.868-5.926V0a14.56 14.56 0 0 0-9.507 4.181l1.771 1.767a12.05 12.05 0 0 1 7.736-3.44m7.639 7.439 1.884-1.885h-7.321l1.886 1.885zM5.908 8.062l1.883 1.885h3.552l1.885-1.885zm9.784 5.271.706.727 1.179-1.207v-2.575l-1.885-1.859zm0 7.059 1.885-1.885v-2.56l-1.178-1.18-.707.705zm5.798-1.529h-3.553l-1.884 1.882h7.321zM13.573 8.434l-1.884 1.86v2.565l1.177 1.2.707-.724zM2.508 15.323H.001a14.54 14.54 0 0 0 3.943 9.247l1.771-1.772a12.06 12.06 0 0 1-3.207-7.475m2.499 10.273a14.56 14.56 0 0 0 8.845 3.578v-2.508a12.07 12.07 0 0 1-7.074-2.839zm1.608-11.191.941.942h4.022l.943-.942-.943-.943H7.556zM5.131 7.049 3.344 5.265a14.53 14.53 0 0 0-3.343 8.583h2.507a12.03 12.03 0 0 1 2.623-6.799m8.441 8.423-.707-.706-1.177 1.172v2.55l1.884 1.883zm-.344 5.273-1.886-1.882H7.79l-1.883 1.882zM24.831 4.181A14.55 14.55 0 0 0 15.324 0v2.508a12.05 12.05 0 0 1 7.736 3.44zm1.836 9.666h2.508a14.54 14.54 0 0 0-3.344-8.583l-1.785 1.785a12.06 12.06 0 0 1 2.621 6.798m-3.208 8.951 1.771 1.772a14.53 14.53 0 0 0 3.944-9.247h-2.508a12.05 12.05 0 0 1-3.207 7.475m-8.135 3.868v2.509a14.57 14.57 0 0 0 8.845-3.578l-1.771-1.771a12.07 12.07 0 0 1-7.074 2.84"
        />
    </svg>
);

export default DisplaySVG;
